import React from 'react';
import { useAuth } from '@medical/shared/contexts/AuthContext';
import Login from './Login';
import LoadingSpinner from '@medical/shared/components/LoadingSpinner';
import ForcePasswordChange from '@medical/shared/components/ForcePasswordChange';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user, updateUser, logout } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  if (user?.mustChangePassword) {
    return (
      <ForcePasswordChange
        accountLabel={user.patientId}
        onSignOut={logout}
        onChanged={() => updateUser({ mustChangePassword: false })}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
